{
  "cldrVersion": "48.2.0",
  "cities": {
    "fr": {
      "Africa/Addis_Ababa": "Addis-Abeba",
      "Africa/Algiers": "Alger",
      "Africa/Asmera": "Asmara",
      "Africa/Cairo": "Le Caire",
      "Africa/El_Aaiun": "Laâyoune",
      "Africa/Lome": "Lomé",
      "Africa/Mogadishu": "Mogadiscio",
      "Africa/Ndjamena": "N’Djamena",
      "Africa/Sao_Tome": "São Tomé",
      "Africa/Tripoli": "Tripoli (Libye)",
      "America/Araguaina": "Araguaína",
      "America/Argentina/Rio_Gallegos": "Río Gallegos",
      "America/Argentina/Tucuman": "Tucumán",
      "America/Argentina/Ushuaia": "Ushuaïa",
      "America/Asuncion": "Asunción",
      "America/Bahia_Banderas": "Bahia de Banderas",
      "America/Barbados": "La Barbade",
      "America/Belem": "Belém",
      "America/Bogota": "Bogotá",
      "America/Cancun": "Cancún",
      "America/Cayman": "Caïmans",
      "America/Ciudad_Juarez": "Ciudad Juárez",
      "America/Coral_Harbour": "Atikokan",
      "America/Cordoba": "Córdoba",
      "America/Cuiaba": "Cuiabá",
      "America/Curacao": "Curaçao",
      "America/Detroit": "Détroit",
      "America/Dominica": "Dominique",
      "America/Eirunepe": "Eirunepé",
      "America/Godthab": "Nuuk",
      "America/Grenada": "Grenade",
      "America/Havana": "La Havane",
      "America/Indiana/Knox": "Knox [Indiana]",
      "America/Indiana/Marengo": "Marengo [Indiana]",
      "America/Indiana/Petersburg": "Petersburg [Indiana]",
      "America/Indiana/Tell_City": "Tell City [Indiana]",
      "America/Indiana/Vevay": "Vevay [Indiana]",
      "America/Indiana/Vincennes": "Vincennes [Indiana]",
      "America/Indiana/Winamac": "Winamac [Indiana]",
      "America/Jamaica": "Jamaïque",
      "America/Kentucky/Monticello": "Monticello [Kentucky]",
      "America/Lower_Princes": "Lower Prince’s Quarter",
      "America/Maceio": "Maceió",
      "America/Manaus": "Manaos",
      "America/Mazatlan": "Mazatlán",
      "America/Merida": "Mérida",
      "America/Mexico_City": "Mexico",
      "America/Miquelon": "Saint-Pierre",
      "America/Noronha": "Fernando de Noronha",
      "America/North_Dakota/Beulah": "Beulah (Dakota du Nord)",
      "America/North_Dakota/Center": "Center (Dakota du Nord)",
      "America/North_Dakota/New_Salem": "New Salem (Dakota du Nord)",
      "America/Port_of_Spain": "Port-d’Espagne",
      "America/Puerto_Rico": "Porto Rico",
      "America/Santarem": "Santarém",
      "America/Santo_Domingo": "Saint-Domingue",
      "America/Sao_Paulo": "São Paulo",
      "America/Scoresbysund": "Ittoqqortoormiit",
      "America/St_Barthelemy": "Saint-Barthélemy",
      "America/St_Johns": "Saint-Jean de Terre-Neuve",
      "America/St_Kitts": "Saint-Christophe",
      "America/St_Lucia": "Sainte-Lucie",
      "America/St_Thomas": "Saint-Thomas",
      "America/St_Vincent": "Saint-Vincent",
      "America/Thule": "Thulé",
      "Antarctica/DumontDUrville": "Dumont-d’Urville",
      "Antarctica/Syowa": "Showa",
      "Asia/Almaty": "Alma Ata",
      "Asia/Aqtau": "Aktaou",
      "Asia/Aqtobe": "Aktioubinsk",
      "Asia/Ashgabat": "Achgabat",
      "Asia/Atyrau": "Atyraou",
      "Asia/Baghdad": "Bagdad",
      "Asia/Bahrain": "Bahreïn",
      "Asia/Baku": "Bakou",
      "Asia/Beirut": "Beyrouth",
      "Asia/Bishkek": "Bichkek",
      "Asia/Calcutta": "Calcutta",
      "Asia/Chita": "Tchita",
      "Asia/Damascus": "Damas",
      "Asia/Dubai": "Dubaï",
      "Asia/Dushanbe": "Douchanbé",
      "Asia/Famagusta": "Famagouste",
      "Asia/Hebron": "Hébron",
      "Asia/Hovd": "Khovd",
      "Asia/Irkutsk": "Irkoutsk",
      "Asia/Jerusalem": "Jérusalem",
      "Asia/Kabul": "Kaboul",
      "Asia/Kamchatka": "Kamtchatka",
      "Asia/Katmandu": "Katmandou",
      "Asia/Krasnoyarsk": "Krasnoïarsk",
      "Asia/Kuwait": "Koweït",
      "Asia/Macau": "Macao",
      "Asia/Makassar": "Macassar",
      "Asia/Manila": "Manille",
      "Asia/Muscat": "Mascate",
      "Asia/Nicosia": "Nicosie",
      "Asia/Novosibirsk": "Novossibirsk",
      "Asia/Oral": "Ouralsk",
      "Asia/Qostanay": "Kostanaï",
      "Asia/Qyzylorda": "Kzyl Orda",
      "Asia/Rangoon": "Rangoun",
      "Asia/Riyadh": "Riyad",
      "Asia/Saigon": "Hô-Chi-Minh-Ville",
      "Asia/Sakhalin": "Sakhaline",
      "Asia/Samarkand": "Samarcande",
      "Asia/Seoul": "Séoul",
      "Asia/Singapore": "Singapour",
      "Asia/Tashkent": "Tachkent",
      "Asia/Tbilisi": "Tbilissi",
      "Asia/Tehran": "Téhéran",
      "Asia/Ulaanbaatar": "Oulan-Bator",
      "Asia/Urumqi": "Ürümqi",
      "Asia/Yakutsk": "Iakoutsk",
      "Asia/Yekaterinburg": "Ekaterinbourg",
      "Asia/Yerevan": "Erevan",
      "Atlantic/Azores": "Açores",
      "Atlantic/Bermuda": "Bermudes",
      "Atlantic/Canary": "Îles Canaries",
      "Atlantic/Cape_Verde": "Cap-Vert",
      "Atlantic/Faeroe": "Îles Féroé",
      "Atlantic/Madeira": "Madère",
      "Atlantic/South_Georgia": "Géorgie du Sud",
      "Atlantic/St_Helena": "Sainte-Hélène",
      "Australia/Adelaide": "Adélaïde",
      "Etc/Unknown": "lieu inconnu",
      "Europe/Andorra": "Andorre",
      "Europe/Athens": "Athènes",
      "Europe/Brussels": "Bruxelles",
      "Europe/Bucharest": "Bucarest",
      "Europe/Busingen": "Büsingen",
      "Europe/Chisinau": "Chișinău",
      "Europe/Copenhagen": "Copenhague",
      "Europe/Guernsey": "Guernesey",
      "Europe/Isle_of_Man": "Île de Man",
      "Europe/Kiev": "Kiev",
      "Europe/Lisbon": "Lisbonne",
      "Europe/London": "Londres",
      "Europe/Malta": "Malte",
      "Europe/Moscow": "Moscou",
      "Europe/San_Marino": "Saint-Marin",
      "Europe/Tirane": "Tirana",
      "Europe/Ulyanovsk": "Oulianovsk",
      "Europe/Vatican": "Le Vatican",
      "Europe/Vienna": "Vienne",
      "Europe/Warsaw": "Varsovie",
      "Indian/Comoro": "Comores",
      "Indian/Mahe": "Mahé",
      "Indian/Mauritius": "Maurice",
      "Indian/Reunion": "La Réunion",
      "Pacific/Easter": "Île de Pâques",
      "Pacific/Efate": "Éfaté",
      "Pacific/Enderbury": "Canton",
      "Pacific/Fiji": "Fidji",
      "Pacific/Galapagos": "Galápagos",
      "Pacific/Honolulu": "Honolulu",
      "Pacific/Marquesas": "Marquises",
      "Pacific/Noumea": "Nouméa",
      "Pacific/Palau": "Palaos",
      "Pacific/Ponape": "Pohnpei",
      "Pacific/Truk": "Chuuk",
      "Pacific/Wallis": "Wallis & Futuna"
    },
    "en": {
      "Africa/Asmera": "Asmara",
      "Africa/El_Aaiun": "El Aaiún",
      "Africa/Lome": "Lomé",
      "Africa/Ndjamena": "N’Djamena",
      "Africa/Sao_Tome": "São Tomé",
      "America/Araguaina": "Araguaína",
      "America/Argentina/Rio_Gallegos": "Río Gallegos",
      "America/Argentina/Tucuman": "Tucumán",
      "America/Asuncion": "Asunción",
      "America/Bahia_Banderas": "Bahía de Banderas",
      "America/Belem": "Belém",
      "America/Bogota": "Bogotá",
      "America/Cancun": "Cancún",
      "America/Ciudad_Juarez": "Ciudad Juárez",
      "America/Coral_Harbour": "Atikokan",
      "America/Cordoba": "Córdoba",
      "America/Cuiaba": "Cuiabá",
      "America/Curacao": "Curaçao",
      "America/Eirunepe": "Eirunepé",
      "America/Godthab": "Nuuk",
      "America/Indiana/Knox": "Knox, Indiana",
      "America/Indiana/Marengo": "Marengo, Indiana",
      "America/Indiana/Petersburg": "Petersburg, Indiana",
      "America/Indiana/Tell_City": "Tell City, Indiana",
      "America/Indiana/Vevay": "Vevay, Indiana",
      "America/Indiana/Vincennes": "Vincennes, Indiana",
      "America/Indiana/Winamac": "Winamac, Indiana",
      "America/Kentucky/Monticello": "Monticello, Kentucky",
      "America/Lower_Princes": "Lower Prince’s Quarter",
      "America/Maceio": "Maceió",
      "America/Mazatlan": "Mazatlán",
      "America/Merida": "Mérida",
      "America/Mexico_City": "Mexico City",
      "America/Miquelon": "Saint-Pierre",
      "America/Noronha": "Fernando de Noronha",
      "America/North_Dakota/Beulah": "Beulah, North Dakota",
      "America/North_Dakota/Center": "Center, North Dakota",
      "America/North_Dakota/New_Salem": "New Salem, North Dakota",
      "America/Santarem": "Santarém",
      "America/Sao_Paulo": "São Paulo",
      "America/Scoresbysund": "Ittoqqortoormiit",
      "America/St_Barthelemy": "St. Barthélemy",
      "America/St_Johns": "St. John’s",
      "America/St_Kitts": "St. Kitts",
      "America/St_Lucia": "St. Lucia",
      "America/St_Thomas": "St. Thomas",
      "America/St_Vincent": "St. Vincent",
      "Antarctica/Casey": "Casey Station",
      "Antarctica/DumontDUrville": "Dumont d’Urville Station",
      "Antarctica/Macquarie": "Macquarie Island",
      "Antarctica/Mawson": "Mawson Station",
      "Antarctica/McMurdo": "McMurdo Station",
      "Antarctica/Palmer": "Palmer Land",
      "Antarctica/Rothera": "Rothera Station",
      "Antarctica/Syowa": "Showa Station",
      "Antarctica/Troll": "Troll Station",
      "Antarctica/Vostok": "Vostok Station",
      "Asia/Aqtau": "Aktau",
      "Asia/Calcutta": "Kolkata",
      "Asia/Hovd": "Khovd",
      "Asia/Katmandu": "Kathmandu",
      "Asia/Macau": "Macao",
      "Asia/Qostanay": "Kostanay",
      "Asia/Qyzylorda": "Kyzylorda",
      "Asia/Rangoon": "Yangon",
      "Asia/Saigon": "Ho Chi Minh City",
      "Asia/Urumqi": "Ürümqi",
      "Atlantic/Canary": "Canaries",
      "Atlantic/Faeroe": "Faroes",
      "Atlantic/St_Helena": "St. Helena",
      "Australia/Lord_Howe": "Lord Howe Island",
      "Etc/Unknown": "Unknown Location",
      "Europe/Busingen": "Büsingen",
      "Europe/Chisinau": "Chișinău",
      "Europe/Kiev": "Kyiv",
      "Europe/Tirane": "Tirana",
      "Indian/Chagos": "Chagos Archipelago",
      "Indian/Christmas": "Christmas Island",
      "Indian/Cocos": "Cocos Islands",
      "Indian/Comoro": "Comoros",
      "Indian/Kerguelen": "Kerguelen Islands",
      "Indian/Mahe": "Mahé",
      "Indian/Reunion": "Réunion",
      "Pacific/Chatham": "Chatham Islands",
      "Pacific/Easter": "Easter Island",
      "Pacific/Enderbury": "Canton Island",
      "Pacific/Galapagos": "Galápagos Islands",
      "Pacific/Kwajalein": "Kwajalein Atoll",
      "Pacific/Marquesas": "Marquesas Islands",
      "Pacific/Midway": "Midway Atoll",
      "Pacific/Norfolk": "Norfolk Island",
      "Pacific/Noumea": "Nouméa",
      "Pacific/Pitcairn": "Pitcairn Islands",
      "Pacific/Ponape": "Pohnpei",
      "Pacific/Truk": "Chuuk",
      "Pacific/Wake": "Wake Island",
      "Pacific/Wallis": "Wallis & Futuna"
    },
    "de": {
      "Africa/Addis_Ababa": "Addis Abeba",
      "Africa/Algiers": "Algier",
      "Africa/Asmera": "Asmara",
      "Africa/Cairo": "Kairo",
      "Africa/Dar_es_Salaam": "Daressalam",
      "Africa/Djibouti": "Dschibuti",
      "Africa/El_Aaiun": "El Aaiún",
      "Africa/Khartoum": "Khartum",
      "Africa/Lome": "Lomé",
      "Africa/Mogadishu": "Mogadischu",
      "Africa/Ndjamena": "N’Djamena",
      "Africa/Porto-Novo": "Porto Novo",
      "Africa/Sao_Tome": "São Tomé",
      "Africa/Tripoli": "Tripolis",
      "America/Araguaina": "Araguaína",
      "America/Argentina/Rio_Gallegos": "Río Gallegos",
      "America/Argentina/Tucuman": "Tucumán",
      "America/Asuncion": "Asunción",
      "America/Bahia_Banderas": "Bahia Banderas",
      "America/Belem": "Belém",
      "America/Bogota": "Bogotá",
      "America/Cancun": "Cancún",
      "America/Cayman": "Kaimaninseln",
      "America/Ciudad_Juarez": "Ciudad Juárez",
      "America/Coral_Harbour": "Atikokan",
      "America/Cordoba": "Córdoba",
      "America/Cuiaba": "Cuiabá",
      "America/Curacao": "Curaçao",
      "America/Eirunepe": "Eirunepé",
      "America/Godthab": "Nuuk",
      "America/Havana": "Havanna",
      "America/Indiana/Knox": "Knox, Indiana",
      "America/Indiana/Marengo": "Marengo, Indiana",
      "America/Indiana/Petersburg": "Petersburg, Indiana",
      "America/Indiana/Tell_City": "Tell City, Indiana",
      "America/Indiana/Vevay": "Vevay, Indiana",
      "America/Indiana/Vincennes": "Vincennes, Indiana",
      "America/Indiana/Winamac": "Winamac, Indiana",
      "America/Jamaica": "Jamaika",
      "America/Kentucky/Monticello": "Monticello, Kentucky",
      "America/Lower_Princes": "Lower Prince’s Quarter",
      "America/Maceio": "Maceió",
      "America/Mazatlan": "Mazatlán",
      "America/Merida": "Merida",
      "America/Mexico_City": "Mexiko-Stadt",
      "America/Miquelon": "Saint-Pierre",
      "America/Noronha": "Fernando de Noronha",
      "America/North_Dakota/Beulah": "Beulah, North Dakota",
      "America/North_Dakota/Center": "Center, North Dakota",
      "America/North_Dakota/New_Salem": "New Salem, North Dakota",
      "America/Santarem": "Santarém",
      "America/Sao_Paulo": "São Paulo",
      "America/Scoresbysund": "Ittoqqortoormiit",
      "America/St_Barthelemy": "Saint-Barthélemy",
      "America/St_Johns": "St. John’s",
      "America/St_Kitts": "St. Kitts",
      "America/St_Lucia": "St. Lucia",
      "America/St_Thomas": "St. Thomas",
      "America/St_Vincent": "St. Vincent",
      "Antarctica/DumontDUrville": "Dumont-d’Urville",
      "Antarctica/Syowa": "Showa",
      "Antarctica/Vostok": "Wostok",
      "Asia/Aqtobe": "Aktobe",
      "Asia/Ashgabat": "Aşgabat",
      "Asia/Baghdad": "Bagdad",
      "Asia/Bishkek": "Bischkek",
      "Asia/Brunei": "Brunei Darussalam",
      "Asia/Calcutta": "Kalkutta",
      "Asia/Chita": "Tschita",
      "Asia/Damascus": "Damaskus",
      "Asia/Dushanbe": "Duschanbe",
      "Asia/Hong_Kong": "Hongkong",
      "Asia/Hovd": "Chowd",
      "Asia/Kamchatka": "Kamtschatka",
      "Asia/Karachi": "Karatschi",
      "Asia/Katmandu": "Kathmandu",
      "Asia/Khandyga": "Chandyga",
      "Asia/Krasnoyarsk": "Krasnojarsk",
      "Asia/Macau": "Macau",
      "Asia/Muscat": "Maskat",
      "Asia/Nicosia": "Nikosia",
      "Asia/Novokuznetsk": "Nowokuznetsk",
      "Asia/Novosibirsk": "Nowosibirsk",
      "Asia/Pyongyang": "Pjöngjang",
      "Asia/Qatar": "Katar",
      "Asia/Qostanay": "Qostanai",
      "Asia/Qyzylorda": "Qysylorda",
      "Asia/Rangoon": "Rangun",
      "Asia/Riyadh": "Riad",
      "Asia/Saigon": "Ho-Chi-Minh-Stadt",
      "Asia/Sakhalin": "Sachalin",
      "Asia/Singapore": "Singapur",
      "Asia/Taipei": "Taipeh",
      "Asia/Tashkent": "Taschkent",
      "Asia/Tbilisi": "Tiflis",
      "Asia/Tehran": "Teheran",
      "Asia/Tokyo": "Tokio",
      "Asia/Urumqi": "Ürümqi",
      "Asia/Vladivostok": "Wladiwostok",
      "Asia/Yakutsk": "Jakutsk",
      "Asia/Yekaterinburg": "Jekaterinburg",
      "Asia/Yerevan": "Eriwan",
      "Atlantic/Azores": "Azoren",
      "Atlantic/Canary": "Kanaren",
      "Atlantic/Cape_Verde": "Cabo Verde",
      "Atlantic/Faeroe": "Färöer",
      "Atlantic/Reykjavik": "Reyk­ja­vík",
      "Atlantic/South_Georgia": "Südgeorgien",
      "Atlantic/St_Helena": "St. Helena",
      "Etc/Unknown": "Unbekannt",
      "Europe/Astrakhan": "Astrachan",
      "Europe/Athens": "Athen",
      "Europe/Belgrade": "Belgrad",
      "Europe/Brussels": "Brüssel",
      "Europe/Bucharest": "Bukarest",
      "Europe/Busingen": "Büsingen",
      "Europe/Chisinau": "Chișinău",
      "Europe/Copenhagen": "Kopenhagen",
      "Europe/Kiev": "Kiew",
      "Europe/Kirov": "Kirow",
      "Europe/Lisbon": "Lissabon",
      "Europe/Luxembourg": "Luxemburg",
      "Europe/Moscow": "Moskau",
      "Europe/Prague": "Prag",
      "Europe/Rome": "Rom",
      "Europe/Saratov": "Saratow",
      "Europe/Tirane": "Tirana",
      "Europe/Ulyanovsk": "Uljanowsk",
      "Europe/Vatican": "Vatikan",
      "Europe/Vienna": "Wien",
      "Europe/Volgograd": "Wolgograd",
      "Europe/Warsaw": "Warschau",
      "Europe/Zurich": "Zürich",
      "Indian/Christmas": "Weihnachtsinsel",
      "Indian/Comoro": "Komoren",
      "Indian/Mahe": "Mahé",
      "Indian/Maldives": "Malediven",
      "Indian/Reunion": "Réunion",
      "Pacific/Easter": "Osterinsel",
      "Pacific/Enderbury": "Canton",
      "Pacific/Fiji": "Fidschi",
      "Pacific/Galapagos": "Galápagos",
      "Pacific/Honolulu": "Honolulu",
      "Pacific/Noumea": "Nouméa",
      "Pacific/Ponape": "Pohnpei",
      "Pacific/Truk": "Chuuk",
      "Pacific/Wallis": "Wallis & Futuna"
    }
  }
}
